import styled from 'styled-components'
import { Tag } from '../../../../Tag'

export const StyledTag = styled(Tag)`
  margin-block-start: 0;
  margin-inline-start: 0;
`
